import React, { Component } from 'react';
import { connect } from 'react-redux';
import { resolveLocalizedText } from '../../../../utils';
import { ChangeContactView } from '../../components/ChangeContactView';
import PolicySelect from '../../components/PolicySelect';
import './style.scss';
import { goto } from '../../../../actions/historyActions';
import {
  getChangeAddressLabels,
  getChangeAddressStepContext,
  getOtherPolicyList,
} from '../../selectors/changeAddressSelector';
import { updateSelectedList } from '../../actions/changeAddressAction';
import { getSelectedPolicy } from '../../selectors/changeContactSelector';
import _ from 'lodash';
import EmmaErrorModal from '../../../../components/EmmaErrorModal';
import { contactPermissionPolicy } from '../../types/changeContactService';

export interface UpdateAddressApplyToOtherContainerProps {
  changeAddressLabels: any;
  changeAddressStepContext: any;
  otherPolicyList: any[];
  updateSelectedList: (selectedList: any[]) => any;
  policyDetails: any;
}

export interface UpdateAddressApplyToOtherContainerState {}

export class UpdateAddressApplyToOtherContainer extends Component<
  UpdateAddressApplyToOtherContainerProps,
  UpdateAddressApplyToOtherContainerState
> {
  otherPolicies: contactPermissionPolicy[];
  constructor(props: any) {
    super(props);
    this.state = {};
    const { otherPolicyList, policyDetails } = props;
    this.otherPolicies = otherPolicyList.filter(
      (policy: contactPermissionPolicy) =>
        policy.policyNumber !== policyDetails.policyNumber,
    );
  }

  componentDidMount() {
    const { policyDetails } = this.props;
    if (_.isEmpty(policyDetails)) {
      goto('emma-change-contact', undefined, undefined, true);
    }
  }

  onChangeUpdatePolicyList = (selectedList: any[]) => {
    const { updateSelectedList } = this.props;
    updateSelectedList(selectedList);
  };

  onGoNext = () => {
    goto('emma-customer-profile/changeaddress/review');
  };

  render() {
    const { changeAddressLabels, changeAddressStepContext, policyDetails } =
      this.props;
    const { editAddress, nextBtnLabel, updatePoliciesLabel } =
      changeAddressLabels;
    const resolvedStepContext = resolveLocalizedText(
      changeAddressStepContext,
    ) as any;

    return (
      <div className="change-address">
        <ChangeContactView
          pageName={editAddress ? resolveLocalizedText(editAddress) : ''}
          stepContext={resolvedStepContext}
          activeIndex={0}
        >
          <div className="emma-stylesheet-grid-system">
            <PolicySelect
              policyDetails={policyDetails}
              policyList={this.otherPolicies}
              onChange={this.onChangeUpdatePolicyList}
            />
            <div className="row">
              <button
                className="change-address-button emma-stylesheet-primary-default-button"
                data-enable-ga
                data-ga-type="button"
                onClick={() => this.onGoNext()}
              >
                {nextBtnLabel ? resolveLocalizedText(nextBtnLabel) : ''}
              </button>
            </div>
          </div>
        </ChangeContactView>
        <EmmaErrorModal />
      </div>
    );
  }

  static mapStateToProps(state: any, ownProps: any) {
    const changeAddressLabels = getChangeAddressLabels(state);
    const changeAddressStepContext = getChangeAddressStepContext(state);
    const otherPolicyList = getOtherPolicyList(state);
    const policyDetails = getSelectedPolicy(state);

    return {
      changeAddressLabels,
      changeAddressStepContext,
      otherPolicyList,
      policyDetails,
    };
  }

  static mapDispatchToProps(dispatch: any) {
    return {
      updateSelectedList: (selectedList: any[]) =>
        dispatch(updateSelectedList(selectedList)),
    };
  }
}

export default connect(
  UpdateAddressApplyToOtherContainer.mapStateToProps,
  UpdateAddressApplyToOtherContainer.mapDispatchToProps,
)(UpdateAddressApplyToOtherContainer);
